import styled from "styled-components";

export const ChartsGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ChartPanel = styled.section`
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dfe4ea;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(31, 41, 55, 0.05);
`;

export const ChartHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 42px;
  padding: 10px 12px;
  border-bottom: 1px solid #eef1f4;
  background: #fbfcfd;
`;

export const ChartTitle = styled.h3`
  margin: 0;
  color: #263241;
  font-size: 13px;
  font-weight: 700;
`;

export const ChartCanvas = styled.div`
  width: 100%;
  height: 205px;
  padding: 4px;
`;

export const ChartEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #8a94a3;
  font-size: 12px;
`;
